import { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom'

export const useGTMPageChange = (isPerkins: boolean) => {
  const location = useLocation()

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'page_view',
        pagePath: location.pathname,
        siteID: isPerkins ? 'emcperkins' : 'emccat',
      },
    })
  }, [location.pathname])
}
